import { makeStyles } from '@material-ui/core/styles';

export const useCommonStyles = makeStyles(() => ({
  container: {
    display: 'grid',
    placeItems: 'center',
    fontFamily: "'Mulish', sans-serif",
  },
  grid: {
    maxWidth: '764px',
  },
  inputWrapper: {
    width: '100%',
    minHeight: '80px',
  },
  header: {
    display: 'grid',
    gridGap: '16px',
    marginBottom: '40px',
    fontFamily: "'Mulish', sans-serif",
  },
  banner: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '16px',
  },
}));
